import { useEffect } from 'react'

import Grid from '../components/grid'
import { setCurrentPath } from '../state/ui'
import { useTvShows } from '../queries/media'
import { castSend } from '../tools/cast'

export default function TvShows() {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useTvShows()

  useEffect(() => {
    castSend({ type: 'home' })
    setCurrentPath([])
  }, [])

  return (
    <Grid
      shows={data ?? []}
      infiniteFunc={() => {
        if (hasNextPage && !isFetchingNextPage) fetchNextPage()
      }}
    />
  )
}
